import * as React from 'react';

import { QuizQuestionUrl } from '../../../../api/question/questionApi';

const QuizQuestionUrlContext = React.createContext<QuizQuestionUrl>(undefined);

interface Props {
  quizQuestionUrl: QuizQuestionUrl;
  children: React.ReactNode;
}

export function QuizQuestionUrlProvider({ quizQuestionUrl, children }: Props) {
  return (
    <QuizQuestionUrlContext.Provider value={quizQuestionUrl}>
      {children}
    </QuizQuestionUrlContext.Provider>
  );
}

export function useQuizQuestionUrl() {
  const value = React.useContext(QuizQuestionUrlContext);
  if (value === undefined) {
    throw new Error(
      'QuizQuestionURLContextValue is not defined. Ensure this component is wrapped with a QuizQuestionUrlProvider '
    );
  }
  return value;
}
